import React from 'react';
import { Layers, Hammer, Wrench, ArrowUpRight } from 'lucide-react';
import { services } from '../mock';
import Reveal from './Reveal';

const iconMap = { Layers, Hammer, Wrench };

const Services = () => {
  return (
    <section id="services" className="relative py-24 md:py-36 bg-[#F1EBE1]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <span className="section-num text-sm">02 — Services</span>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] text-[#1a1a1a] max-w-xl">
                Three disciplines,
                <br />
                <span className="italic">one obsession</span> — stone.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={150}>
            <p className="text-[#4a463f] max-w-md text-[15px] leading-relaxed">
              From quarry-fresh slabs to the final polished install, we hold every
              step of the journey under one roof — so nothing is lost in translation.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Layers;
            return (
              <Reveal key={s.id} delay={i * 120}>
                <a
                  href={s.href || '#contact'}
                  className="card-lift bg-[#FAF7F2] rounded-sm overflow-hidden h-full flex flex-col group cursor-pointer"
                >
                  <div className="img-zoom relative aspect-[4/3]">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute top-4 left-4 w-11 h-11 rounded-full bg-[#FAF7F2]/95 backdrop-blur-sm flex items-center justify-center text-[#7B1E24]">
                      <Icon size={18} strokeWidth={1.6} />
                    </div>
                    <div className="absolute top-4 right-4 text-[11px] tracking-[0.2em] uppercase font-medium text-white bg-[#1a1a1a]/70 backdrop-blur-sm px-3 py-1 rounded-full">
                      0{i + 1}
                    </div>
                  </div>
                  <div className="p-7 lg:p-8 flex flex-col flex-1">
                    <h3 className="font-serif text-2xl md:text-[26px] text-[#1a1a1a]">{s.title}</h3>
                    <p className="mt-1 text-[13px] tracking-wide text-[#B8935A] italic">{s.subtitle}</p>
                    <p className="mt-4 text-[#4a463f] text-[15px] leading-relaxed flex-1">
                      {s.description}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase font-medium text-[#7B1E24] group-hover:gap-3 transition-all">
                      {s.id === 'supply' ? 'View Collection' : 'Enquire'} <ArrowUpRight size={14} />
                    </span>
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
